export const SET_CONTEXT_USER = 'SET_CONTEXT_USER';
export const RESET_CONTEXT_USER = 'RESET_CONTEXT_USER';
export const PREVIOUS_CONTEXT_USER = 'PREVIOUS_CONTEXT_USER';
export const SET_CONTEXT_USER_PERMISSIONS = 'SET_CONTEXT_USER_PERMISSIONS';
export const SET_CONTEXT_USER_ADDITIONAL_INFO = 'SET_CONTEXT_USER_ADDITIONAL_INFO';
